// Generated by spriteMerger.js
import { ComponentProps } from 'react';
import Icon from '../Icon';
import file from './file.svg';

interface FileIconProps extends Omit<ComponentProps<typeof Icon>, 'link'> {
  name: FileNames;
}

export function FileIcon({ name, ...props }: FileIconProps) {
  return <Icon {...props} link={file} name={name} />
}

type FileNames =
  | 'approval'
  | 'attach_email'
  | 'attachment'
  | 'cloud_circle'
  | 'cloud_done'
  | 'cloud_download'
  | 'cloud_off'
  | 'cloud_queue'
  | 'cloud_sync'
  | 'cloud_upload'
  | 'cloud'
  | 'create_new_folder'
  | 'difference'
  | 'download_done'
  | 'download_for_offline'
  | 'download'
  | 'downloading'
  | 'drive_file_move_rtl'
  | 'drive_file_move'
  | 'drive_file_rename_outline'
  | 'drive_folder_upload'
  | 'file_download_done'
  | 'file_download_off'
  | 'file_open'
  | 'file_upload'
  | 'folder_copy'
  | 'folder_delete'
  | 'folder_off'
  | 'folder_open'
  | 'folder_shared'
  | 'folder_zip'
  | 'folder'
  | 'format_overline'
  | 'grid_view'
  | 'newspaper'
  | 'request_quote'
  | 'rule_folder'
  | 'snippet_folder'
  | 'text_snippet'
  | 'topic'
  | 'upload_file'
  | 'workspaces'
;

